import React from 'react';
import {
  Button,
  Grid,
  Box,
  CssBaseline,
  TextField,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Navbar from "../../Component/NavPannel/Navbar";
import LoginFooter from "../../Component/NavPannel/LoginFooter";
import LoginRegister from "../../Component/SidePannel/LoginRegister";
import "../../Styles/Login.css";
import { useFormik } from "formik";
import { useNavigate } from "react-router";
import { loginschema } from "../../Component/Schemas/loginSchema";
import { useDispatch } from "react-redux";
import { UserSignIn } from "../../redux/Actions/authAction";
import {GetUserRoles, GetUsers} from '../../redux/Actions/userStatusService'
const theme = createTheme();

export default function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const initialValues = { email: "", password: "" };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues,
    validationSchema: loginschema,
    onSubmit: async (values) => {
      try {
        const { email, password } = values;
        const portal = "ADMIN";
        const result = await dispatch(UserSignIn({ email, password, portal }));
    
        if (result.type === "UserSignIn/fulfilled") {
          // Handle successful login
          const response = await dispatch(GetUserRoles("ADMIN"));
          if (response && response?.payload.statusCode === 200) {
            localStorage.setItem('lastActivity', Date.now().toString());
            const type = response?.payload?.data[0]?.role;
            localStorage.setItem("type", type);
            if (type === 'SUPER_ADMIN') {
              localStorage.setItem("parentId", response?.payload?.data[0]?.id);
            } else {
              const userResponse = await dispatch(GetUsers(type));
              if (userResponse && userResponse?.payload.statusCode === 200) {
                const parentId= userResponse?.payload.data[0]?.parentUserRole?.id;
                localStorage.setItem("parentId", parentId);
              }
            }
            navigate("/dashboard");
          }
        } else if (result.type === "UserSignIn/rejected") {
          // Show error message from rejected action
          const errorMessage = result.payload?.message || "Login failed. Please check your credentials.";
          alert(errorMessage); // Display error message
          console.error("Login failed:", result);
        }
      } catch (error) {
        console.error("Error during login:", error);
      }
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Navbar page="Sign Up" link="register" />
      <Grid container component="main">
        <CssBaseline />
        <LoginRegister />
        <Grid item xs={12} sm={12} md={6} elevation={6}>
          <form onSubmit={handleSubmit}>
            <Box
              sx={{
                my: 12,
                mx: 12,
                maxHeight: "680px",
                marginTop: "110px",
                marginLeft: "150px",
                marginRight: "150px",
              }}
            >
              <Grid>
                <b style={{ fontSize: "26px" }}>Sign in to Admin Panel</b>
              </Grid>
              <br />
              <Box noValidate sx={{ mt: 1 }}>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.email && touched.email && (
                  <p className="form-error" style={{ color: "red", fontSize: "11px" }}>
                    {errors.email}
                  </p>
                )}
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Password"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {errors.password && touched.password && (
                  <p className="form-error" style={{ color: "red", fontSize: "11px" }}>
                    {errors.password}
                  </p>
                )}
                <br />
                <br />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 1, mb: 2 }}
                  style={{
                    backgroundColor: "#1976d2",
                    color: "white",
                    height: "45px",
                  }}
                >
                  Sign In
                </Button>
                <div
                  xs={false}
                  sm={4}
                  md={6}
                  style={{ marginTop: "140px", marginBottom: "-100px" }}
                >
                  <LoginFooter />
                </div>
              </Box>
            </Box>
          </form>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
